//common
require('./anime.ts');

// const header = document.querySelector('header');
// window.addEventListener('scroll',function(){
//   var sH = window.scrollY;
//   if(sH >= 800){
//     header.classList.add('hScroll');
//   }else{
//     header.classList.remove('hScroll');
//   }
// });





// 追記ここから
gsap.registerPlugin(ScrollTrigger);

// オープニング
gsap.fromTo(".opn_bg", {
  autoAlpha: 1,
},
{
  autoAlpha: 0,
  duration: 1,
  delay: 0.2,
  ease: "power2.inOut",
});